const regexAlphaNumeric = /^[a-zA-Z ]*$/;

export const isValidInput = (value) => regexAlphaNumeric.test(value);
